import React, {useCallback, useEffect, useState} from "react";
import {Col, Container, Row} from "react-bootstrap";
import {AdminUserGrid} from "../Components/AdminUsers/AdminUserGrid";
import {AdminCompanyGrid} from "../Components/AdminCompany/AdminCompanyGrid";
import {getAllCompanies, getAllUsers, getAllLeads} from "../../services/AdminService";
import LoadingLoginScreen from "../../components/LoadingLoginScreen";
import {AdminStatistics} from "../Components/AdminStatistics";
import {AdminLeadGrid} from "../Components/AdminLeads/AdminLeadGrid";
import {Card} from "react-bootstrap";
import {AdminOnboardDashboard} from "./AdminOnboardDashboard";

export const AdminDashboard = () => {
    const [allCompanies, setAllCompanies] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [allLeads, setAllLeads] = useState([]);
    const [loading, setLoading] = useState(true);


    const fetchValues = useCallback(async () => {

        try {
            setLoading(true);

            const companies = await getAllCompanies();
            const users = await getAllUsers();
            const leads = await getAllLeads();

            setAllCompanies(companies);
            setAllUsers(users);
            setAllLeads(leads);

            setLoading(false);

        } catch (error) {
            console.error("Error when fetching companies from AdminDashboard", error);
        }
    }, []);


    useEffect(() => {

        fetchValues();
    }, [fetchValues]);

    return (
        <Container>

            {loading ? <LoadingLoginScreen/> :
                <Container>
                    <Row>
                        <Card>
                            <AdminStatistics companies={allCompanies} users={allUsers} leads={allLeads}/>
                        </Card>
                    </Row>
                    <hr/>
                    <Row>
                        <Col>
                            <AdminUserGrid users={allUsers}/>
                        </Col>
                        <hr/>
                        <Col>
                            <AdminCompanyGrid companies={allCompanies}/>
                        </Col>
                        <hr/>
                        <Row>
                            <Col>
                                <AdminLeadGrid leads={allLeads}/>
                            </Col>
                        </Row>
                    </Row>
                </Container>
            }
        </Container>
    )
}
